import { Link } from 'react-router-dom'
import { trackPlatformClick } from '../../lib/analytics'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div>
            <Link to="/" className="footer-logo">
              <img src="/brand/cs-icon-white.svg" alt="CorpStage" />
              <span className="footer-logo-text">CorpStage</span>
            </Link>
            <p className="footer-desc">Governance infrastructure for ESG and AI. Built for organisations that need it to hold up under scrutiny. CorpStage Pte Ltd · Singapore · contact@corpstage.com</p>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <span className="pill pill-green" style={{ fontSize: '0.7rem' }}>ISSB Aligned</span>
              <span className="pill pill-teal" style={{ fontSize: '0.7rem' }}>EU AI Act</span>
            </div>
          </div>
          <div>
            <div className="footer-col-h">Platforms</div>
            <a className="fl" href="https://corpstage.app" target="_blank" rel="noreferrer" onClick={() => trackPlatformClick('corpstage.app')}>CorpStage ESG 360</a>
            <a className="fl" href="https://aivara.corpstage.app" target="_blank" rel="noreferrer" onClick={() => trackPlatformClick('aivara.corpstage.app')}>AIVARA Core 360 (Free Trial)</a>
            <Link className="fl" to="/portal/login">Portal Login</Link>
          </div>
          <div>
            <div className="footer-col-h">Solutions</div>
            <Link className="fl" to="/solutions/esg-roi-for-ceos">ESG ROI for CEOs</Link>
            <Link className="fl" to="/solutions/esg-operating-model-design">ESG Operating Model</Link>
            <Link className="fl" to="/solutions/esg-audit-assurance-readiness">Audit and Assurance</Link>
            <Link className="fl" to="/solutions/sustainable-capital-readiness">Sustainable Capital</Link>
          </div>
          <div>
            <div className="footer-col-h">Academy</div>
            <Link className="fl" to="/academy/cec-001">Certified ESG Controller</Link>
            <Link className="fl" to="/academy/caigl-001">Certified AI Governance Lead</Link>
            <Link className="fl" to="/academy/caiap-001">Certified AI Assurance Practitioner</Link>
            <Link className="fl" to="/academy/cairo-001">Certified AI Risk Officer</Link>
          </div>
          <div>
            <div className="footer-col-h">Company</div>
            <Link className="fl" to="/about">About Us</Link>
            <Link className="fl" to="/case-studies">Case Studies</Link>
            <Link className="fl" to="/insights">Insights</Link>
            <Link className="fl" to="/contact">Contact</Link>
            <Link className="fl" to="/press">Press</Link>
            <Link className="fl" to="/esg-operating-model-diagnostic">ESG Operating Model Diagnostic</Link>
            <Link className="fl" to="/esg-maturity-assessment">ESG Maturity Assessment</Link>
            <Link className="fl" to="/ask-iris">Ask IRIS</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 CorpStage Pte Ltd. All rights reserved.</span>
          <span>Privacy Policy · Terms of Use</span>
        </div>
      </div>
    </footer>
  )
}
